import * as React from "react";
import { ReactElement, useState } from "react";
import "./LeaderboardWidget.scss";
import { LeaderboardWidgetProps, LeaderboardWidgetPosition } from "./LeaderboardWidget.types";
import LeaderboardItem from "./LeaderboardItem";
import { shallowEqual, useSelector } from "react-redux";
import { IApplicationState } from "src/spintr/reducer";
import { Label, SpintrUser, UserHovercard } from "src/ui";
import { circleSmall } from "src/ui/helpers/style";
import classNames from "classnames";

function LeaderboardWidget({ data, variables }: LeaderboardWidgetProps): ReactElement {
  const [positions, setPositions] = useState<LeaderboardWidgetPosition[]>(data.positions);

  const {
    currentUser
  } = useSelector((state: IApplicationState) => ({
    currentUser: state.profile.active
  }), shallowEqual);

  return (
    <div className={classNames("LeaderboardWidget-container", {
      "isPreview": data.isPreview,
    })}>
      <div className="content">
        {positions.map((item, index) => (
          <>
            <LeaderboardItem
              key={item.email || item.officeCode + index}
              item={item}
              isOnPodium={item.ranking <= 3}
              typeOfStatistics={data.typeOfStatistics}
              variables={variables}
              isCurrentUser={item.id === currentUser.id} />
            {index < positions.length - 1 && (
              <div className="LeaderboardWidget-separator" />
            )}
          </>
        ))}
      </div >
    </div >
  );
};

export default LeaderboardWidget;
